import { INSTAGRAM_URL, TELEGRAM_URL } from '../config/media';

function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="mt-auto border-t border-gray-200 px-5 py-10 md:px-10 md:py-12">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-6 md:gap-8">
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-8">
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="font-sans text-[0.8125rem] uppercase tracking-[0.08em] text-black no-underline transition-opacity hover:opacity-60"
          >
            Instagram
          </a>
          <a
            href={TELEGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="font-sans text-[0.8125rem] uppercase tracking-[0.08em] text-black no-underline transition-opacity hover:opacity-60"
          >
            Telegram
          </a>
        </div>

        <p className="m-0 text-center text-xs text-neutral-500 md:text-sm">© 2026 Idelia Shagieva</p>

        <button
          type="button"
          onClick={scrollToTop}
          aria-label="Наверх"
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-neutral-300 bg-transparent text-neutral-600 transition-colors hover:border-black hover:text-black"
        >
          <svg
            width="12"
            height="16"
            viewBox="0 0 12 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path d="M6 15V2M6 2L1 7M6 2L11 7" stroke="currentColor" strokeWidth="1.2" />
          </svg>
        </button>
      </div>
    </footer>
  );
}

export default Footer;
